// guest api
export const POST_GUEST_LINK = () =>
  `https://app.rankspro.io/api/user/guestlink/`;

export const GET_IS_GUEST_LINK_VALID = (link) =>
  `https://app.rankspro.io/api/user/getguestlink/
?link=${link}`;
